import { useState, useRef } from "react";
import { useEffect } from "react";
import RealtimeChart from "../../components/RealtimeChart";

export default function Live() {
  const rerenderCounter = useRef(0);
  const [_, setCounter] = useState(0);
  const list = useRef<number[]>([]);

  function rerender() {
    setCounter(rerenderCounter.current++);
  }

  useEffect(() => {
    const sse: EventSource = new EventSource("/api/serversentevents");

    sse.onmessage = (event) => {
      console.log(event.data);
      list.current = [
        parseFloat(event.data),
        ...list.current.slice(0, 100)
      ];
      rerender();
    };
    sse.onerror = (event) => {
      rerender();
    };
    sse.onopen = (event) => {
      rerender();
    };

    return () => {
        sse.close();
        }
  }, []);

  return (
    <div className="container">
      <h1>Chart</h1>
      <RealtimeChart
        id="chart"
        data={list.current}
      ></RealtimeChart>
    </div>
  );
}
